// Utilities
import { defineStore } from 'pinia'

export const useFavoriteStore = defineStore('favorite', {
  state: () => ({
    favorites: []
  }),

  getters: {},

  actions: {
    isFavorited (station) {
      return this.favorites.includes(station?.stationuuid)
    },

    toggleFavorite (station) {
      if (!station) {
        return
      }

      const index = this.favorites.indexOf(station?.stationuuid)
      if (index === -1) {
        this.favorites.push(station.stationuuid)
      } else {
        this.favorites.splice(index, 1)
      }
    }
  },

  persist: {
    storage: localStorage,
    pick   : undefined,
    omit   : undefined
  }
})
